export default __webpack_public_path__ + "static/media/040_tunnel.first.332c3d6a.avif";